import React, { useState, useEffect, useCallback } from 'react';
import { Pagination as PG, IPagination } from '@apia/components';
import { useResponsiveTableContext } from '../ResponsiveTableContext';
import useIsMaximized from './useIsMaximized';
import { usePrevious } from '@apia/util';

const NoMemoPagination = ({
  listId: outerListId,
  onPageChange,
  ...props
}: Omit<IPagination, 'isMaximized' | 'onMaximize'> & { listId: string }) => {
  const listId = useResponsiveTableContext().name;
  const { isMaximized, toggleIsMaximized } = useIsMaximized(
    outerListId ?? listId,
  );

  const numberCurrentPage = Number(props.currentPage);

  const [internCurrentPage, setCurrentPage] = useState<number>(
    numberCurrentPage ?? 1,
  );

  const [lastEmittedPage, setLastEmittedPage] = useState<number>(
    numberCurrentPage ?? 1,
  );

  const previousPage = usePrevious(props.currentPage);
  if (previousPage.current !== props.currentPage) {
    setLastEmittedPage(props.currentPage as any);
  }

  const setCurrentAndDispatch = useCallback(
    (page: number) => {
      if (page !== lastEmittedPage) {
        setCurrentPage(page);
        onPageChange?.(page);
        setLastEmittedPage(page);
      }
    },
    [lastEmittedPage, onPageChange],
  );

  useEffect(() => {
    setCurrentPage(numberCurrentPage);
  }, [numberCurrentPage]);

  return (
    <PG
      {...{ ...props, isMaximized, onMaximize: toggleIsMaximized }}
      currentPage={internCurrentPage}
      onPageChange={setCurrentAndDispatch}
    />
  );
};

export const Pagination = React.memo(NoMemoPagination);
